export default '/build/4ce2c81c.svg'